<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Yeni Ödeme Tarihi</label>
            <v-date-picker v-model="value.Date" placeholder="Yeni Ödeme Tarihi"></v-date-picker>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>